import styled from "styled-components";
import { Outlet, useNavigate } from "react-router-dom";
import ContractIcon from "../components/icon/contractIcon";
import PenIcon from "../components/icon/penIcon";
import { useState } from "react";
import react, { useEffect } from "react";
import { Toast } from "../components/common/toastMessegeComponent";
import TruckIcon from "../components/icon/truckIcon";
import LockIcon from "../components/icon/lockIcon";
import BlankBoxIcon from "../components/icon/blankBox";
import PopupModal from "./popupModal";
import API from "../API/API";
const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: start;
  height: 80vh;
  width: 100%;
`;
const MarginBox = styled.div`
  margin-top: 5vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const ContentBox = styled.div`
  display: flex;
  align-items: center;
  width: 58vw;
  border-radius: 0.8vw;
  margin-bottom: 2vw;
  justify-content: space-between;

  /* outline: 5px solid green; */
`;
const Content = styled.div<{
  $bgColor?: string;
  $outLine?: string;
  $hoverBgColor?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 28vw;
  height: 28vw;
  border-radius: 0.8vw;
  background-color: ${(props) => (props.$bgColor ? props.$bgColor : "#fff6ee")};
  justify-content: center;
  /* outline: 0.2vw solid gray; */
  /* margin: 0.7vh 0vh 0.7vh 0vh; */
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.01),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.009);
  /* outline: 0.1vw solid
    ${(props) => (props.$outLine ? props.$outLine : "#fff6ee")}; */
  &:hover {
    background-color: ${(props) =>
      props.$hoverBgColor ? props.$hoverBgColor : "#fff6ee"};
    cursor: pointer;
  }
`;
const Icon = styled.div`
  margin-bottom: 2vw;
`;
const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 9vw;
  width: 100%;
  justify-content: start;
`;
const SiteTitle = styled.div`
  color: #ffffff;
  font-size: 3vw;
  font-weight: 700;
`;

const SubTitle = styled.div`
  color: #ffffff;
  font-size: 1.4vw;
  font-weight: 100;
  width: 80%;
  text-align: center;
  line-height: 2vw;
  margin-top: 2vw;
`;

export default function LandingPage() {
  const loginUser = JSON.parse(localStorage.getItem("loginUser") || "{}");
  const [fetchStatus, setFetchStatus] = useState(false); // toast messege
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState<any[]>([]);
  const onClose = () => {
    setPopupVisible(false);
  };
  const navigate = useNavigate();
  const detailPageShow = () => {
    navigate(`contractlist`);
  };

  const sitePageShow = () => {
    navigate(`onsitecontract`);
  };

  const mattressPageShow = () => {
    navigate(`mattress`);
  };

  const plumberPageShow = () => {
    navigate(`plumber`);
  };

  const moveToIntroductionPage = () => {
    navigate(`introduction`);
  };

  const moveToEnterpriseContractList = () => {
    navigate(`enterpriseContractList`);
  };

  //sitePage 출입방지용 임시 toastModal
  const disabledSite = () => {
    setFetchStatus(true);
  };

  //----- 팝업 불러오기
  const getPopupList = async () => {
    try {
      const response = await API.get("notice/list");

      const noticeList = response.data.result.noticeList;

      setPopupContent(response.data.result.noticeList);
    } catch (error) {
      alert(error);
    }
  };
  useEffect(() => {
    getPopupList();
  }, []);

  useEffect(() => {
    if (popupContent.length > 0) {
      setPopupVisible(true);
    }
  }, [popupContent]);

  return (
    <>
      {/* {popupVisible && (
        <PopupModal popupContent={popupContent} onClose={onClose}></PopupModal>
      )} */}
      <Container>
        {fetchStatus && (
          <Toast
            text={"준비 중 입니다."}
            setFetchStatus={setFetchStatus}
            fetchStatus={fetchStatus}
            status={"FAIL"}
          />
        )}
        {loginUser.userType !== "mattress" &&
          loginUser.userType !== "plumber" && (
            <MarginBox>
              <ContentBox>
                <Content
                  $bgColor={"#FF8646"}
                  onClick={detailPageShow}
                  $hoverBgColor={"#ffb188"}
                  // $outLine={"#ff7f3b"}
                >
                  <Icon>
                    <ContractIcon height={"6vw"} fill={"#ffffff"} />
                  </Icon>
                  <TitleBox>
                    <SiteTitle>{"견적 토스건"}</SiteTitle>
                    <SubTitle>
                      {"나에게 배정된 견적 및 계약, 작업"}
                      <br />
                      {" 리스트들을 관리합니다."}
                    </SubTitle>
                  </TitleBox>
                </Content>
                <Content
                  // onClick={disabledSite}
                  onClick={() => sitePageShow()}
                  $bgColor={"#6AD958"}
                  $hoverBgColor={"#93e187"}
                >
                  <Icon>
                    <TruckIcon height={"6.2vw"} fill={"#ffffff"} />
                  </Icon>
                  <TitleBox>
                    <SiteTitle>{"지점 자체건"}</SiteTitle>
                    <SubTitle>
                      {"현장에서 자체 견적을 통해 "}
                      <br />
                      {"통인CS에 견적을 접수합니다."}
                    </SubTitle>
                  </TitleBox>
                </Content>
              </ContentBox>
              <ContentBox>
                <Content
                  $bgColor={"#EC5151"}
                  $hoverBgColor={"#ec5151d3"}
                  onClick={() => window.open(`https://tonginexpress.com/`)}
                >
                  <Icon>
                    <BlankBoxIcon height={"6vw"} fill={"#ffffff"} />
                  </Icon>
                  <TitleBox>
                    <SiteTitle>{"통인 자재몰"}</SiteTitle>
                    <SubTitle>{"바로가기"}</SubTitle>
                  </TitleBox>
                </Content>
                <Content
                  onClick={moveToIntroductionPage}
                  $bgColor={"#FFC700"}
                  $hoverBgColor={"#ffc800c4"}
                >
                  <Icon>
                    <LockIcon height={"6vw"} fill={"#ffffff"} />
                  </Icon>
                  <TitleBox>
                    <SiteTitle>{"홍보 자료"}</SiteTitle>
                    <SubTitle>{"홍보 자료 바로가기"}</SubTitle>
                  </TitleBox>
                </Content>
              </ContentBox>
              <ContentBox>
                {loginUser.isCompanyContractTeam ? (
                  <Content
                    $bgColor={"#0C8CE9"}
                    $hoverBgColor={"#0c8de9e1"}
                    onClick={moveToEnterpriseContractList}
                  >
                    <Icon>
                      <BlankBoxIcon height={"6vw"} fill={"#ffffff"} />
                    </Icon>
                    <TitleBox>
                      <SiteTitle>{"기업 이전"}</SiteTitle>
                      <SubTitle>{"기업 이전 접수하기"}</SubTitle>
                    </TitleBox>
                  </Content>
                ) : (
                  <Content
                    onClick={disabledSite}
                    $bgColor={"#DBDBDB"}
                    $hoverBgColor={"##ffffff"}
                  >
                    <Icon>
                      <LockIcon height={"6vw"} fill={"#ffffff"} />
                    </Icon>
                    <TitleBox>
                      <SiteTitle>{"기업 이전"}</SiteTitle>
                      <SubTitle>{"기업이전팀만 이용 가능합니다."}</SubTitle>
                    </TitleBox>
                  </Content>
                )}
                <Content
                  onClick={disabledSite}
                  $bgColor={"#DBDBDB"}
                  $hoverBgColor={"##ffffff"}
                >
                  <Icon>
                    <LockIcon height={"6vw"} fill={"#ffffff"} />
                  </Icon>
                  <TitleBox>
                    <SiteTitle>{"준비 중"}</SiteTitle>
                    <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                  </TitleBox>
                </Content>
              </ContentBox>
            </MarginBox>
          )}

        {/* 매트리스 케어 전용 화면 */}
        {loginUser.userType === "mattress" && (
          <MarginBox>
            <ContentBox>
              <Content
                $bgColor={"#FF8646"}
                onClick={mattressPageShow}
                $hoverBgColor={"#ffb188"}
                // $outLine={"#ff7f3b"}
              >
                <Icon>
                  <ContractIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"매트리스케어"}</SiteTitle>
                  <SubTitle>
                    {"매트리스케어 접수 및 상품들을"}
                    <br />
                    {"관리합니다."}
                  </SubTitle>
                </TitleBox>
              </Content>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
            </ContentBox>
            <ContentBox>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
            </ContentBox>
          </MarginBox>
        )}

        {/* 배관케어 전용화면 */}
        {loginUser.userType === "plumber" && (
          <MarginBox>
            <ContentBox>
              <Content
                $bgColor={"#0C8CE9"}
                onClick={plumberPageShow}
                $hoverBgColor={"#0c8de9e1"}
              >
                <Icon>
                  <ContractIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"배관케어"}</SiteTitle>
                  <SubTitle>
                    {"배관케어 접수 및 상품들을"}
                    <br />
                    {"관리합니다."}
                  </SubTitle>
                </TitleBox>
              </Content>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
            </ContentBox>
            <ContentBox>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
              <Content
                onClick={disabledSite}
                $bgColor={"#DBDBDB"}
                $hoverBgColor={"##ffffff"}
              >
                <Icon>
                  <LockIcon height={"6vw"} fill={"#ffffff"} />
                </Icon>
                <TitleBox>
                  <SiteTitle>{"준비 중"}</SiteTitle>
                  <SubTitle>{"서비스 준비 중 입니다."}</SubTitle>
                </TitleBox>
              </Content>
            </ContentBox>
          </MarginBox>
        )}
      </Container>
    </>
  );
}
